module.exports = __webpack_public_path__ + "static/media/Classic T VR.8c778e5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/Classic T VR.mp3
// module id = 6ZiR
// module chunks = 12